import React, { Component } from "react";
import { formatISO } from "date-fns";
import { DatePicker } from "antd";




export default class DateInput extends Component 
{
    constructor(props)
    {
        super(props);

        this.onDateChange = this.onDateChange.bind(this);
    }


    onDateChange(ev){
        console.log("date changed");
        console.log(ev);
        // don't do anything until we get both dates.
        if (!ev) return;
    
        var sd = new Date(ev.$y, ev.$M, ev.$D); //, ev[0].$H, ev[0].$m);
        this.props.onValueChange(formatISO(sd));

    
    
    
      }


    render() 
    {
        return(                

            <DatePicker 
                size='large'
                //defaultPickerValue={parseISO(this.props.cardValue)}
                //defaultValue={parseISO(this.props.cardValue)}
                onChange={(e) => this.onDateChange(e)}
                onValueChange={(ev) => this.onDateChange(ev)}
                onDateChange={(ev) => this.onDateChange(ev)}
                onCalendarChange={(ev) => this.onDateChange(ev)}
                getPopupContainer={(triggerNode) => {
                    return triggerNode.parentNode;
                  }}
            />

        )
    }
}







